const statsTypes = {
  RESET_DAILY_TIKTOK_CAMPAIGN_INSIGHT_STATE:
    'RESET_DAILY_TIKTOK_CAMPAIGN_INSIGHT_STATE',
  DAILY_TIKTOK_CAMPAIGN_INSIGHTS: {
    REQUEST: 'DAILY_TIKTOK_CAMPAIGN_INSIGHTS.REQUEST',
    SUCCESS: 'DAILY_TIKTOK_CAMPAIGN_INSIGHTS.SUCCESS',
    FAILURE: 'DAILY_TIKTOK_CAMPAIGN_INSIGHTS.FAILURE',
  },
};

export default statsTypes;
